export default __webpack_public_path__ + "static/hexagonal-571aea1cd121891d45464359fb8f14cb.png";